import React from 'react';
import { Sprite } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';

interface GeoAdminLegendProps {
  layerName: string;
}

const GeoAdminLegend = ({ layerName }: GeoAdminLegendProps) => {
  const { t } = useTranslation('agisviewer');
  const url = `https://api3.geo.admin.ch/rest/services/api/MapServer/${layerName}/legend?lang=de`;

  return (
    <a className="legend__extern-link" href={url} target="_blank" rel="noreferrer">
      <Sprite id="i-circle" additionalClassNames="legend__icon" />
      <span>{t('extern_link')}</span>
    </a>
  );
};

export default GeoAdminLegend;
